<template>
	<svg height="16" viewBox="0 0 448 512" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m0 64h448v64h-448zm0 160h448v64h-448zm448 160v64h-448v-64z"/></svg>
</template>

<script>
	export default {
		name: "Bars"
	}
</script>